import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/master-org-chart?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/master-org-chart', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/master-org-chart/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/master-org-chart/${body.id}`, body.body);
};
export const GET_LIST = () => {
    return axiosIns.get(`/master-org-chart/list`);
};